import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import { CloudMapping } from './components/onboarding/cloud-mapping';
import { Complete } from './components/onboarding/complete';
import { Installation } from './components/onboarding/installation';
import { InstallationSuccess } from './components/onboarding/installation-success';
import { Welcome } from './components/onboarding/welcome';
import { DatabricksOnboard } from './pages/databricks';
import { DatabricksHelp } from './pages/databricks/help';
import { Home } from './pages/home';
import SlackAppLanding from './pages/public/slack-app-landing/slack-app-landing';
import { Status } from './pages/status';

const Router = BrowserRouter as any;
const RouteComponent = Route as any;
const SwitchComponent = Switch as any;
const RedirectComponent = Redirect as any;

export const Routes: React.FC = () => {
  return (
    <Router>
      <SwitchComponent>
        {/* Main routes */}
        <RouteComponent exact path="/" component={Home} />
        <RouteComponent exact path="/slack" component={Home} />
        <RouteComponent exact path="/status" component={Status} />
        
        {/* Onboarding step routes */}
        <RouteComponent exact path="/slack/onboard/welcome" component={Welcome} />
        <RouteComponent exact path="/slack/onboard/installation" component={Installation} />
        <RouteComponent exact path="/slack/onboard/sitedetails" component={CloudMapping} />
        <RouteComponent exact path="/slack/onboard/complete" component={Complete} />
        
        {/* Slack installation success route */}
        <RouteComponent exact path="/slack/installation/success" component={InstallationSuccess} />

        {/* Databricks onboard */}
        <RouteComponent exact path="/databricks/onboard" component={DatabricksOnboard} />
        <RouteComponent exact path="/databricks/help" component={DatabricksHelp} />
        
        {/* Public routes does not require authentication, Any route that starts with /public will not force user to login */}
        <RouteComponent exact path="/public/rovoApp" component={SlackAppLanding} />

        {/* Redirect any unknown routes to home */}
        <RouteComponent path="*">
          <RedirectComponent to="/" />
        </RouteComponent>
      </SwitchComponent>
    </Router>
  );
};
